import * as shared from "@/styles/shared";
import type { StepIndicatorProps } from "@shared/types/setup";
import { Step } from "@shared/types/setup";
import { CheckCircle2 } from "lucide-react";
import * as pageStyles from "../../pages/SetupWizardPage.styles";
import { stepIcons } from "./StepIndicator.constants";
import * as styles from "./StepIndicator.styles";

const StepIndicator = ({ currentStep, t, stepOrder }: StepIndicatorProps) => {
  const currentIndex = stepOrder.indexOf(currentStep);

  return (
    <div className={pageStyles.progressContainer}>
      {stepOrder.map((step, index) => {
        const isActive = index === currentIndex;
        const isCompleted = index < currentIndex;

        const stepLabel = step === Step.Bank ? t("step1Title") : step === Step.Address ? t("step2Title") : t("step3Title");
        const StepIcon = stepIcons[step];

        return (
          <div key={index} className={styles.segmentContainer}>
            {index > 0 && (
              <div className={styles.progressBarContainer}>
                {currentIndex > index ? (
                  <div className={styles.progressBarCompleted} />
                ) : currentIndex === index ? (
                  <div className={styles.progressBarActive}>
                    <div className={styles.progressBarActiveFill} />
                  </div>
                ) : (
                  <div className={styles.progressBarPending} />
                )}
              </div>
            )}
            <div
              className={`${styles.segmentCircle} ${isCompleted ? styles.segmentCircleCompleted : isActive ? styles.segmentCircleActive : styles.segmentCirclePending}`}
            >
              {isCompleted ? (
                <CheckCircle2 className={shared.iconSm} />
              ) : (
                <StepIcon className={`${shared.iconSm} ${isActive ? styles.iconTextPrimary : shared.mutedBase}`} />
              )}
            </div>
            <span className={`${styles.segmentLabel} ${isActive ? styles.segmentLabelActive : undefined}`}>{stepLabel}</span>
          </div>
        );
      })}
    </div>
  );
};

export { StepIndicator };
